import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./Record.css"
import Api from '../api/api';
import demo from "../record.json"
import intl from 'react-intl-universal';
export default class Record extends Component {
  constructor(props) {
    super();
    this.state = {
      list: []
    };
  }

  componentDidMount() {
    // this.setState({list:demo.data.records})
    this.getRecord();
  }

  render() {
    return (
      <div className="record">
        {this.state.list.length > 0 && this.state.list.map((item, index) => (
          <div className="record-item" key={index}>
            <div className="hd">
              <div>{item.device_time.replace('T', ' ')}</div>
            </div>
            <div className="bd">
              <div className="bd__car">
                <div style={{ textAlign: 'center' }}>
                  <Car
                    statusArr={[
                      item.wear_lf_degree,
                      item.wear_rf_degree,
                      item.wear_lb_degree,
                      item.wear_rb_degree
                    ]}
                  />
                  <p style={{ marginTop: 10 }}>{intl.get('txt_msqk')}</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <Car
                    statusArr={[
                      item.wear_lf_degree,
                      item.wear_rf_degree,
                      item.wear_lb_degree,
                      item.wear_rb_degree
                    ]}
                  />
                  <p style={{ marginTop: 10 }}>{intl.get('txt_sldwd')}</p>
                </div>
              </div>
              <div className="bd__info">
                  <p><span>{intl.get('txt_khsj')}：{item.mobile ? item.mobile : '-'}</span></p>
                  <p><span>{intl.get('txt_cphm')}：{item.plate_no ? item.plate_no : '-'}</span></p>
                  <p><span>{intl.get('txt_clxh')}：{item.car ? item.car : '-'}</span></p>
              </div>
            </div>
            <div className="ft">
              <button className="btn"><Link to={`/report/${item.uuid}`}>{intl.get('txt_ckbg')}</Link></button>
            </div>
          </div>
        ))
        }
        {this.state.list.length === 0 && (
          <p className="nothing">{intl.get('txt_NoData')}</p>
        )}
      </div>
    )
  }

  getRecord() {
    Api.getRecords({
      qs: this.getQueryString('qs'),
      staff_number: this.getQueryString('staff_number'),
    }).then(res => {
      if (res.data.code === 0) {
        this.setState({ list: res.data.data.reports })
      }
    })
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

}
const styles = {
  wrap: {
    position: 'relative',
    width: 44,
    height: 85,
  },
  car: {
    width: '100%',
    height: '100%',
  },
  tyre: {
    position: 'absolute',
    borderRadius: 4,
    width: 10,
    height: 22.5,
  },
  tyre0: {
    // 左前
    left: 0,
    top: 10,
  },
  tyre1: {
    // 右前
    right: 0,
    top: 10,
  },
  tyre2: {
    // 左后
    left: 0,
    bottom: 10,
  },
  tyre3: {
    // 右后
    right: 0,
    bottom: 10,
  }
}

const Car = props => {
  let _tyre = props.statusArr.map((item, index) => {
    let _color = item === 'low' ? '#36B37E' : (item === 'high' ? '#FF5230' : '#FFAD26');
    return (
      <div style={Object.assign({}, styles.tyre, styles[`tyre${index}`], { backgroundColor: _color })} key={index}></div>
    );
  });
  return (
    <div style={styles.wrap}>
      {<img src={require("../assets/report/car_large.png")} alt="" />}
      {_tyre}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/views/Record.jsx